// extracted by mini-css-extract-plugin
module.exports = {"icon":"Delete_icon__3kRtq"};